<template>
  <div>
    <div class="container" v-if="formSent == false">
      <div class="row">
        <div class="form-group col-12 col-md-4">
          <label class="d-none d-sm-block" for="companyContactFirstName">First Name <span class="req">*</span></label>
          <input type="text" tabindex="1" v-model="firstName" class="form-control" v-on:keyup="checkForHighlight" id="companyContactFirstName" placeholder="First Name">
        </div>
        <div class="form-group col-12 col-md-4">
          <label class="d-none d-sm-block" for="companyContactLastName">Last Name <span class="req">*</span></label>
          <input type="text" tabindex="2"  v-model=lastName class="form-control" v-on:keyup="checkForHighlight" id="companyContactLastName" placeholder="Last Name">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <label class="d-none d-sm-block" for="primaryEmail">Email <span class="req">*</span></label>
          <input type="text" tabindex="3" v-model=email class="form-control" v-on:keyup="checkForHighlight" id="primaryEmail" placeholder="Email">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12 col-md-4">
          <label class="d-none d-sm-block" for="companyZipAddress">Zip Code <span class="req">*</span></label>
          <input type='text' tabindex="4" v-mask="'#####'" class="form-control" v-model="zipcode" id="companyZipAddress" @keyup="getCityStateFromZip" @change="getCityStateFromZip" placeholder="Zip Code">
          <small id="passwordHelpBlock" class="form-text text-muted">Fill in the Zip Code first and we will try to find your city and state for you.</small>
        </div>
        <div class="form-group col-12 col-md-8" id="showCityStateHere">
        </div>
      </div>
      <div class="row justify-content-center">
        <button class="col-12 col-md-6" @click="shortFormSubmitted" :disabled="disableSend" tabindex="5">Complete Background Check!</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mask} from 'vue-the-mask';

export default {
  directives: {mask},
  name: 'BacNumber',
  props: {
  },
  data: function() {
    return {
      firstName: '',
      lastName: '',
      address: '',
      city: '',
      state: '',
      zipcode: '',
      email: '',
      disableSend: true,
      formSent: false
    }
  },
  methods: {
    getCityStateFromZip: function(e) {
      let bacForm = this;
      if(e.currentTarget.classList.contains("highlight")) {
        e.currentTarget.classList.remove("highlight");
      }
      if(e.currentTarget.value.length == 5) {
        axios.get("/wp-content/plugins/vue-form/excelApi/getCityStateFromZipcode.php?pc="+e.currentTarget.value)
          .then(function(response){
            let data = response.data;
            document.getElementById("showCityStateHere").innerText = data.primary_city + ', ' + data.state;
            bacForm.backgroundCharge = data.total_price;
            bacForm.zipcode = data.zip;
            bacForm.$emit('cityUpdate', data.primary_city);
            bacForm.$emit('stateUpdate', data.state);
            bacForm.$emit('zipUpdate', data.zip);
            bacForm.$emit('bgChargeUpdate', bacForm.backgroundCharge);
            bacForm.checkSendable();
          });
      }
    },
    checkForHighlight: function(e) {
      let panelOne = this;
      if(e.currentTarget.classList.contains("highlight")) {
        e.currentTarget.classList.remove("highlight");
      }
      if(e.currentTarget.id == 'companyContactFirstName') {
        panelOne.firstName = e.currentTarget.value;
        panelOne.$emit('firstNameUpdate', e.currentTarget.value);
      }
      if(e.currentTarget.id == 'companyContactLastName') {
        panelOne.lastName = e.currentTarget.value;
        panelOne.$emit('lastNameUpdate', e.currentTarget.value);
      }
      if(e.currentTarget.id == 'primaryEmail') {
        panelOne.email = e.currentTarget.value;
        panelOne.$emit('emailUpdate', e.currentTarget.value);
      }
      panelOne.checkSendable();
    },
    checkSendable: function() {
      if(this.firstName == '' || this.lastName == '' || this.zipcode == '' || this.email == ''){
        console.log("disable button");
        this.disableSend = true;
      } else {
        console.log("enable button");
        this.disableSend = false;
      }
    },
    shortFormSubmitted: function() {
      this.$emit('update', true);
      this.$emit('updatePayment', this.backgroundCharge);
      window.scrollTo(0,0);
      let allFields = Array.prototype.slice.call(document.getElementsByTagName("input"), 0);
      let proceed = true;
      let submitToXls = [];

      for(let index = 0; index < allFields.length; index++) {
        if(allFields[index].type == "text") {
          if(allFields[index].value == "" && allFields[index].parentElement.querySelectorAll(".req").length > 0) {
            allFields[index].classList.add("highlight");
            proceed = false;
          } else {
            let name = allFields[index].id,
              value = allFields[index].value,
              obj = { [name] : [value][0] };
            submitToXls.push(obj);
          }
        }
      }
      let panelOne = this;
      if(proceed == true){
        axios.get("/wp-content/plugins/vue-form/excelApi/getFileFromInfo.php?z=" + panelOne.zipcode + "&fn=" + panelOne.firstName + "&ln=" + panelOne.lastName + "&em=" + panelOne.email)
            .then(function(response){
              if(response == '0 results') {
                let data = response.data;
                panelOne.zipcode = data.PostalCode;
                panelOne.address = data.Address;
                panelOne.city = data.City;
                panelOne.state = data.State;
                panelOne.$emit('companyUpdate', data.Company);
                panelOne.$emit('addressUpdate', data.Address);
                panelOne.$emit('cityUpdate', data.City);
                panelOne.$emit('stateUpdate', data.State);
                panelOne.$emit('companyFeinUpdate', data.CompanyFein);
                panelOne.$emit('bgChargeUpdate', panelOne.backgroundCharge);
                panelOne.$emit('showInterstitialChange', true);
              } else {
                panelOne.$emit('companyUpdate', panelOne.Company);
                panelOne.$emit('addressUpdate', panelOne.Address);
                panelOne.$emit('cityUpdate', panelOne.City);
                panelOne.$emit('stateUpdate', panelOne.State);
                panelOne.$emit('companyFeinUpdate', panelOne.CompanyFein);
                panelOne.$emit('bgChargeUpdate', panelOne.backgroundCharge);
                panelOne.$emit('showInterstitialChange', true);
              }
            });
      } else {
        panelOne.$emit('update', false);
      }
    }
  }
}
</script>

<style scoped>
  .req { color: #a94442; }
  label, legend { font-weight: bold; }
  .highlight { background: #fdd !important;}
  #showCityStateHere { margin-top: 40px; }
</style>
